import React from "react";
import { Link } from 'react-router-dom'
import HeaderNav from "../misc/headerNav"
import "../Component/Home.css"
import CreateStory from "../Component/CreateStory"
import PostingList from "./PostingList.jsx"

export default class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userElement: [],
            searchWord: "",
            sortValue: "Recent",
            sortIndex: 0,
            genError: false,
            genRes: "",
        };
    }

    componentDidMount() {
        this.loadUsers();
    }

    // Here we will load all the users AKA Michael
    loadUsers() {

        fetch(process.env.REACT_APP_API_PATH + "/users", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then(res => {

                if (!res.ok) {
                    this.setState({
                        genError: true,
                        genres: "Failed to load leaderboard content, this is not your fault please reload the page."
                    });
                    return;
                }

                return res.json();
            })
            .then(
                result => {
                    if (result) {

                        // This will sort the list of users based on the likes of the list
                        result[0].sort(function (a, b) {
                            return b.attributes.totalLikes - a.attributes.totalLikes;
                        });

                        this.setState({
                            userElement: result[0].slice(0, 6)
                        });
                    }
                },
                error => {
                    console.log("An error has occured in fetch users!!!!")
                }
            );
    }

    // This will check the list and make sure to increment all items on the list AKA Michael
    locatePosition(number) {
        let compare = "", ret = "";
        compare = String(number);

        if (compare[compare.length - 1] === '1') {
            if (compare.length > 1) {
                if (compare[compare.length - 2] === '1') {
                    ret = "th";
                } else {
                    ret = "st";
                }
            } else {
                ret = "st";
            }
        } else if (compare[compare.length - 1] === '2') {
            ret = "nd";
        } else if (compare[compare.length - 1] === '3') {
            ret = "rd";
        } else {
            ret = "th";
        }
        return ret;
    }

    getSearchWord = (data) => {
        this.setState({ searchWord: data })
    }

    changeSortValue = (sort, sI) => {
        this.setState({ sortValue: sort, sortIndex: sI })
    }
    render() {
        return (
            <div className="homepageMain">
                <HeaderNav searchWord={this.getSearchWord} />

                {this.state.genError ?
                    <div className="innerError">
                        {this.state.genRes}
                    </div>
                    : ""}

                <div className="homeBox">


                    <div className="leftContentBox">
                        <CreateStory changeSort={this.changeSortValue} />
                        <PostingList type="homePost" searchWord={this.state.searchWord} sortIndex={this.state.sortIndex} sortValue={this.state.sortValue} />
                        {console.log("sortValue", this.state.sortValue)}
                    </div>

                    <div className="rightContentBox">
                        <button type="submit" className="archivedStoriesButton">Archived Stories</button>
                        <div className="leaderboardPreviewBox">
                            <div className="leaderboardPreviewTitle">
                                <input type="submit" value="Leaderboard" className="leaderboardPreviewTitleButton" />
                            </div>
                            <div className="leaderboardPreviewContent">

                                {this.state.genError ? <div>
                                    <div>
                                        {this.genRes}
                                    </div>
                                </div> : ""}

                                {/* This is the mini-leaderboard loop... made by Michael and Ben */}
                                {this.state.userElement.map((user, index) => {
                                    return (

                                        <div className="leaderboardPreviewUser">

                                            <p className="leaderboardRank">
                                                {index + 1}{this.locatePosition(index + 1)}
                                            </p>
                                            <a className="storypic">
                                                <Link to={"/user/" + user.id}>
                                                    <img src={user.attributes.pfp}
                                                        height='35'
                                                        width='35'
                                                        alt={user.attributes.name + " Profile Picture"}
                                                        className='leaderBoradStoryPic'
                                                    />
                                                </Link>
                                            </a>
                                            <p className="leaderboardUserName">
                                                {user.attributes.username}
                                            </p>
                                        </div>
                                    )
                                })}
                            </div>
                            <Link to="/leaderboard">
                                <input type="submit" value="View All" className="leaderboardPreviewViewAllButton" />
                            </Link>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}